<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        nome_tabela: '',
        tabela_extensao: '',
        uuid_cliente: '23e3b686-b8ac-4bc9-8fb3-5181da210fbc',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
        this.dataForm = {
          nome_tabela: '',
          tabela_extensao: '',
          uuid_cliente: '23e3b686-b8ac-4bc9-8fb3-5181da210fbc',
        };
      }
    },
    async checkFormValidity() {
      const { valid } = await this.$refs.refFormData.validate();
      return valid;
    },
  },
};
</script>

<template>
  <b-modal no-close-on-backdrop no-close-on-esc size="md" :id="idModal" :title="titleModal" :ok-title="labelBtnOk"
    ok-variant="success" cancel-variant="secondary" body-bg-variant="light" cancel-title="Cancelar" @ok="validateForm"
    @cancel="$emit('cancel')" @close="$emit('cancel')"
    :ok-disabled="!dataForm.nome_tabela || !dataForm.tabela_extensao">
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Nome da tabela" label-for="nome_tabela">
              <validation-provider #default="{ errors }" name="Nome da tabela" rules="required">
                <b-form-input v-model="dataForm.nome_tabela" id="nome_tabela" :state="errors.length > 0 ? false : null"
                  placeholder="Digite o nome da tabela" :disabled="dataForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Tabela Extensão" label-for="Tabela Extensão">
              <validation-provider #default="{ errors }" name="Tabela Extensão" rules="required">
                <b-form-input v-model="dataForm.tabela_extensao" id="Tabela Extensão"
                  :state="errors.length > 0 ? false : null" placeholder="Digite a tabela extensão"
                  :disabled="dataForm.isDefault" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
